import React, { Fragment } from 'react';
import { concat, filter, includes } from 'lodash';
import SearchBox from '../../../../../components/outline/SearchBox';
import BaseForm from '../../../../../components/form/BaseForm';
import ButtonList from '../../../../../components/ButtonList';
import { setQuickToDate } from '../../../../../lib/common';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import CheckBox from '../../../../../components/input/CheckBox';
import {
  DATE_FORMAT,
  QUICK_DATE_SELECT_BUTTON_TARGET,
  SEARCH_PERIOD_BUTTON_ALL_TYPE,
} from '../../../../../constants/service/common/utilConstants';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import {
  ORDER_RETURN_LIST_SEARCH_DATA_MODEL,
  ORDER_RETURN_LIST_SEARCH_OPTION_MODEL,
} from '../../../../../store/modules/order/models';
import {
  ORDER_SEARCH_PERIOD_BUTTON_LIST,
  SEARCH_ORDER_MANAGER_CHECK_BOX_LIST,
  SEARCH_ORDER_RETURN_STATUS_CHECK_BOX_LIST,
} from '../../../../../constants/service/app/orderConstants';
import './OrderReturnListSearchBox.scss';

const OrderReturnListSearchBox = (props) => {
  const { setData, getList, searchData } = props;
  const { returnRequestDate, orderReturnStatusList, returnAcceptManagerList } = searchData;

  return (
    <SearchBox
      className="order-return-list-search-box"
      onSearch={() => {
        /**
         * 날짜 선택 빠른 키 값이 전체가 아닌 경우에만 기간을 서버로 전송한다.
         * 날짜 선택이 전체인 경우 => quickDateIndex = -1
         */
        getList({
          searchOption: {
            /**
             *  반품 요청 일시
             */
            returnRequestDate:
              returnRequestDate.quickDateIndex !== SEARCH_PERIOD_BUTTON_ALL_TYPE ? returnRequestDate.period : null,
            /**
             *  주문 반품 상태 리스트
             */
            orderReturnStatusList,
            /**
             *  반품 접수자 리스트
             */
            returnAcceptManagerList,
          },
          pagination: LIST_PAGINATION_MODEL,
        });
      }}
      onClear={() => {
        getList({
          searchOption: ORDER_RETURN_LIST_SEARCH_OPTION_MODEL,
          pagination: LIST_PAGINATION_MODEL,
        });
        setData({
          path: [],
          value: ORDER_RETURN_LIST_SEARCH_DATA_MODEL,
        });
      }}
    >
      {/*반품 요청 일시*/}
      <BaseForm
        label="반품 요청 일시"
        content={
          <div className="quick-date-picker">
            {/*날짜 선택 빠른 키*/}
            <ButtonList
              current={returnRequestDate.quickDateIndex}
              list={ORDER_SEARCH_PERIOD_BUTTON_LIST}
              onClick={(data) =>
                setData({
                  path: ['returnRequestDate'],
                  value: setQuickToDate({
                    id: data.id,
                    value: data.value,
                    target: QUICK_DATE_SELECT_BUTTON_TARGET.START_DATE,
                    period: returnRequestDate.period,
                  }),
                })
              }
            />

            {/*날짜 선택*/}
            <DateRangePicker
              value={returnRequestDate.period}
              outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
              onSelect={(period) =>
                setData({
                  path: ['returnRequestDate'],
                  value: setQuickToDate({
                    period,
                  }),
                })
              }
            />
          </div>
        }
      />

      {/*반품 상태*/}
      <BaseForm
        label="반품 상태"
        content={
          <Fragment>
            {SEARCH_ORDER_RETURN_STATUS_CHECK_BOX_LIST.map((item) => (
              <CheckBox
                key={item.id}
                checked={includes(orderReturnStatusList, item.id)}
                text={item.name}
                onChange={(checked) =>
                  setData({
                    path: ['orderReturnStatusList'],
                    value: checked
                      ? concat(orderReturnStatusList, item.id)
                      : filter(orderReturnStatusList, (id) => id !== item.id),
                  })
                }
              />
            ))}
          </Fragment>
        }
      />

      {/*반품 접수자*/}
      <BaseForm
        label="반품 접수자"
        content={
          <Fragment>
            {SEARCH_ORDER_MANAGER_CHECK_BOX_LIST.map((item) => (
              <CheckBox
                key={item.id}
                checked={includes(returnAcceptManagerList, item.id)}
                text={item.name}
                onChange={(checked) =>
                  setData({
                    path: ['returnAcceptManagerList'],
                    value: checked
                      ? concat(returnAcceptManagerList, item.id)
                      : filter(returnAcceptManagerList, (id) => id !== item.id),
                  })
                }
              />
            ))}
          </Fragment>
        }
      />
    </SearchBox>
  );
};

export default OrderReturnListSearchBox;
